import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'
import Typography from 'components/Typography'

import { PRO } from '../../contants'

import classes from './ProCon.module.scss'

/** @type {import("./types").default} */
const ProCon = ({ type = PRO, title, text }) => (
  <div>
    <div className={classes.titleContainer}>
      <Icon
        size={24}
        className={clsx(classes[type === PRO ? 'iconPros' : 'iconCons'], classes.icon)}
        icon={type === PRO ? 'caret-circle-up' : 'caret-circle-down'}
      />
      <Typography variant="body-sm" className={classes.title}>
        {title}
      </Typography>
    </div>
    <Typography variant="body-xs" className={classes.text}>
      {text}
    </Typography>
    <div className={classes.divider} />
  </div>
)

export default ProCon
